import React, {Component} from 'react';
import { Navigate } from 'react-router-dom';

class PrivacyRedirect extends Component {
    render (){
        var link
        if (localStorage.getItem("language")==="en") {link = "/en/privacy"}
        if (localStorage.getItem("language")==="zh_Hant") {link = "/tc/privacy"}
        if (localStorage.getItem("language")==="zh_Hans") {link = "/sc/privacy"}
        if (localStorage.getItem("language")==null || localStorage.getItem("language")==="") {link = "/en/privacy"}
        return (<Navigate to={link}/>)
    }
}

export default PrivacyRedirect;
